import { createSlice } from '@reduxjs/toolkit';
import { pushDynamicTab } from '../utils/dynamicTabs';

const SLICE_VERSION = '1.0';

const DEFAULT_LIST_VIEW_STATE = {
  currentPage: 1,
  locationsPerPage: 50,
};

export const initialState = {
  _version: SLICE_VERSION,

  defaultTabs: [
    { id: 'locations', name: 'Locations', contentType: 'locations' },
  ],

  dynamicTabs: [],
  activeTab: 0,
  listViewState: {
    'locations-table': { ...DEFAULT_LIST_VIEW_STATE },
  },
};

const locationSlice = createSlice({
  name: 'locations',
  initialState,

  reducers: {
    addTab: (state, action) => {
      const payload = action.payload || {};

      const tab = {
        id: payload.id || `dyn-${Date.now()}`,
        name: payload.name || `Location ${state.dynamicTabs.length + 1}`,
        isDynamic: true,
        createdAt: Date.now(),
        contentType: payload.contentType || null,
        locationId: payload.locationId || null,
        data: payload.data || null,
      };

      pushDynamicTab(state, tab, state.defaultTabs.length);
    },

    removeTab: (state, action) => {
      const { tabIndex } = action.payload;
      if (tabIndex < state.defaultTabs.length) return;

      const dynamicIndex = tabIndex - state.defaultTabs.length;
      state.dynamicTabs.splice(dynamicIndex, 1);

      // Snap back to the default Locations tab after closing any dynamic tab
      state.activeTab = 0;
    },

    setActiveTab: (state, action) => {
      const { id, index } = action.payload;

      if (id) {
        const tabs = [...state.defaultTabs, ...state.dynamicTabs];
        const idx = tabs.findIndex((t) => t.id === id);
        if (idx !== -1) {
          state.activeTab = idx;
          return;
        }
      }

      if (index != null) {
        const total = state.defaultTabs.length + state.dynamicTabs.length;
        if (index >= 0 && index < total) {
          state.activeTab = index;
        }
      }
    },

    setListViewState: (state, action) => {
      const { stateKey = 'locations-table', ...rest } = action.payload || {};
      const existing = state.listViewState[stateKey] || { ...DEFAULT_LIST_VIEW_STATE };
      state.listViewState[stateKey] = { ...existing, ...rest };
    },

    resetTabs: (state) => {
      state.dynamicTabs = [];
      state.activeTab = 0;
    },
  },
});

export const { addTab, removeTab, setActiveTab, setListViewState, resetTabs } = locationSlice.actions;

export default locationSlice.reducer;
